{
  "flame": {
    "title": "Flame of Love",
    "currentStreakLabel": "CURRENT STREAK",
    "streakDays_one": "{{count}} day in a row",
    "streakDays_other": "{{count}} days in a row",
    "status": {
      "firstDay": "Do your first practice and light the Flame",
      "atRisk": "Today's practice isn't done yet",
      "milestone": "New milestone reached!",
      "done": "Today's practice is done",
      "neutral": "Keep the Flame alive with today's practice"
    },
    "statusLost_one": "The Flame went out · best streak {{count}} day",
    "statusLost_other": "The Flame went out · best streak {{count}} days",
    "nextMilestone": {
      "label": "Next milestone",
      "remaining_one": "{{count}} day left",
      "remaining_other": "{{count}} days left",
      "fallbackName_one": "{{count}} day",
      "fallbackName_other": "{{count}} days"
    },
    "cta": {
      "practice": "Do your practice",
      "relight": "Light the Flame again"
    },
    "risk": {
      "title": "The Flame is at risk",
      "subtitle": "There's been no practice today — the Flame can fade before midnight."
    },
    "success": {
      "done": "Practice done",
      "milestone": "New milestone reached",
      "subtitle": "Your Flame of Love is safe until tomorrow"
    },
    "a11y": {
      "info": "What is the Flame of Love?",
      "share": "Share your Flame of Love",
      "practice": "Do your practice",
      "art": "Flame of Love"
    },
    "state": {
      "loadingA11y": "Loading the Flame of Love",
      "errorMessage": "Couldn't load the Flame of Love. Try again.",
      "retry": "Try again",
      "retryA11y": "Retry loading the Flame of Love"
    }
  },
  "flameInfo": {
    "title": "What is the Flame of Love?",
    "intro": "The Flame of Love is your streak — it shows how many days in a row you keep the connection with yourself through practice.",
    "close": "Close",
    "scrimA11y": "Close the Flame of Love explanation",
    "eyebrowLost": "STREAK LOST",
    "share": "Share",
    "shareA11y": "Share your Flame of Love",
    "brandTitle": "FLAME OF LOVE",
    "streakLabel": "days in a row",
    "dayUnit": "day",
    "allMilestonesReached": "All milestones reached",
    "milestoneReached": "Next milestone reached",
    "progressLabelA11y": "Progress to the next milestone",
    "rows": {
      "days": {
        "title": "Days in a row",
        "description": "How many days in a row you've done at least one practice. A single action a day is enough to keep the streak going."
      },
      "flame": {
        "title": "The Flame",
        "description": "The symbol of your streak. As long as you practice every day, the Flame burns. Miss a day and it starts to fade."
      },
      "next": {
        "title": "Next milestone",
        "description": "Every milestone is an important point on your path. Reach them to unlock achievements and rewards.",
        "allDone": "All available milestones are reached."
      },
      "milestone": {
        "titleFallback": "Next milestone",
        "description": "The name of the next milestone on your path. It shows what stage your habit has grown into."
      },
      "remaining": {
        "title_one": "{{count}} day left",
        "title_other": "{{count}} days left",
        "reached": "Next milestone reached",
        "description": "How many days are left until the next milestone. Follow your progress and keep getting closer."
      },
      "progress": {
        "title": "Progress ({{percent}}%)",
        "description": "Shows how far you've come toward the next milestone. The more days, the closer the reward."
      }
    },
    "status": {
      "firstDay": {
        "title": "The Flame isn't lit yet",
        "description": "Do your first practice today to light your fire."
      },
      "atRisk": {
        "title": "The Flame is at risk",
        "description": "There's been no practice today — the Flame can fade before midnight."
      },
      "done": {
        "title": "Practice done!",
        "description": "Your Flame of Love is safe until tomorrow."
      },
      "milestone": {
        "title": "New milestone reached!",
        "description": "Your Flame of Love is safe, and a new reward is already open."
      },
      "neutral": {
        "title": "The Flame is burning",
        "description": "Practice today to keep the fire going and hold your streak."
      },
      "lost": {
        "title": "The Flame went out",
        "description": "The day counter is back to zero — the path to the next milestone starts over. Your Soul Light stays with you."
      }
    },
    "a11y": {
      "flameLost": "The Flame of Love has gone out",
      "flameBurning": "The Flame of Love is burning"
    }
  },
  "achievements": {
    "title": "Achievements",
    "summaryTitle": "Your achievements",
    "summaryCounter": "{{earned}} of {{total}}",
    "summarySubtitle": "Follow your path and unlock new badges.",
    "tabs": {
      "earned": "Earned",
      "inProgress": "In progress",
      "future": "Upcoming"
    },
    "status": {
      "earned": "Earned",
      "earnedAt": "Earned {{date}}",
      "progress": "Progress: {{current}}/{{target}}",
      "inProgress": "In progress",
      "locked": "Not unlocked yet"
    },
    "reward": {
      "title": "Achievement reward",
      "line1": "The badge is added to your collection.",
      "line2": "No extra XP is granted."
    },
    "empty": {
      "earned": "No achievements yet. The first ones appear after important steps on the Path of Light.",
      "inProgress": "Nothing in progress right now. Start practising to get closer to the next milestone.",
      "future": "Every available achievement is already unlocked."
    },
    "a11y": {
      "back": "Back",
      "info": "What are achievements?",
      "tab": "{{label}}, {{count}}",
      "card": "{{name}}. {{condition}}. {{status}}"
    },
    "state": {
      "loadingA11y": "Loading achievements",
      "errorTitle": "Could not load achievements",
      "errorMessage": "Please try again.",
      "offlineTitle": "No connection",
      "offlineMessage": "Achievements will appear once you are back online.",
      "retry": "Retry",
      "retryA11y": "Retry loading achievements"
    },
    "unknown": {
      "name": "Unknown achievement",
      "description": "It will appear after the app is updated."
    }
  },
  "achievementsInfo": {
    "title": "What are achievements?",
    "intro": "Achievements are the meaningful milestones of your path. They mark your progress, inspire you to keep going and make the journey more mindful and joyful.",
    "close": "Close",
    "scrimA11y": "Close the achievements explainer",
    "rows": {
      "earned": {
        "title": "Earned",
        "description": "Badges you have already unlocked."
      },
      "inProgress": {
        "title": "In progress",
        "description": "Achievements you are moving towards right now."
      },
      "future": {
        "title": "Upcoming",
        "description": "Achievements you have not started yet."
      }
    },
    "reward": "Each achievement grants a badge; no extra XP is added."
  },
  "soulLightInfo": {
    "title": "What is Soul Light?",
    "intro": "Soul Light is the experience that reflects your activity and progress on the platform.",
    "close": "Close",
    "scrimA11y": "Close the Soul Light explainer",
    "note": "At this stage XP shows your progress and is never spent.",
    "unavailable": "Progress data has not loaded yet.",
    "rows": {
      "currentXp": {
        "title": "Current XP",
        "description": "Shows how much experience you have gathered so far.",
        "value": "{{xp}} XP"
      },
      "nextLevel": {
        "title": "Next level",
        "description": "You are moving towards the «{{level}}» level.",
        "unknown": "The next level opens as you grow.",
        "max": "You are at the highest level."
      },
      "progress": {
        "title": "Progress — {{percent}}%",
        "titlePlain": "Progress",
        "description": "{{remaining}} XP left until the next level.",
        "max": "Every level of the path is already open.",
        "a11y": "Progress towards the next level"
      },
      "sources": {
        "title": "XP sources",
        "practices": "Practices",
        "lives": "Live",
        "media": "Media",
        "comments": "Comments",
        "other": "Other"
      },
      "recent": {
        "title": "Recent grants",
        "description": "Here you see real activities and the experience they brought."
      },
      "more": {
        "title": "How to gain more",
        "description": "Practise, join Live sessions, watch media and take part in conversations."
      }
    }
  },
  "levelInfo": {
    "title": "What is the spiritual path level?",
    "intro": "Your level reflects your overall progress in Agapella. Gather Soul Light and open new steps of the path.",
    "close": "Close",
    "scrimA11y": "Close the spiritual path level explainer",
    "tabs": {
      "levels": "Levels",
      "rewards": "Rewards and abilities",
      "a11y": "Explainer sections"
    },
    "levelNames": {
      "seeker": "Seeker",
      "keeper": "Keeper",
      "master": "Light Guide",
      "grand_master": "Master of Light"
    },
    "current": {
      "eyebrow": "Current level",
      "chip": "Current",
      "xp": "{{xp}} XP",
      "unknown": "Your step is not determined yet"
    },
    "next": {
      "toLevel": "To the «{{name}}» level · {{remaining}} XP",
      "toLevelPlain": "To the «{{name}}» level",
      "summitTitle": "Highest step",
      "summitDescription": "You have walked the whole path — from here it only deepens."
    },
    "progress": {
      "value": "{{percent}}%",
      "a11y": "Progress towards the next level"
    },
    "ladder": {
      "title": "Level ladder",
      "threshold": "{{xp}} XP",
      "state": {
        "passed": "Passed",
        "current": "Current",
        "next": "Next",
        "summit": "Highest step",
        "future": "Ahead"
      }
    },
    "growth": {
      "title": "How the level grows",
      "description": "Your level grows together with the Soul Light you gather. Keep walking your path to open new steps."
    },
    "rewards": {
      "title": "What each level opens",
      "items": {
        "seeker": {
          "1": "Access to the Path of Light.",
          "2": "First achievements.",
          "3": "Personal progress tracking."
        },
        "keeper": {
          "1": "The ability to create your own community.",
          "2": "New achievements and rewards.",
          "3": "Taking part in growing Agapella communities."
        },
        "master": {
          "1": "Extended abilities for hosting Live sessions.",
          "2": "Extended management of your own community.",
          "3": "Access to special materials and events."
        },
        "grand_master": {
          "1": "The ability to become a master's assistant.",
          "2": "The ability to receive moderator rights at the invitation of a master or a community owner.",
          "3": "Taking part in growing the platform.",
          "4": "Special Agapella events and rewards."
        }
      }
    },
    "state": {
      "unavailable": "Progress data has not loaded yet.",
      "retry": "Try again",
      "retryA11y": "Reload the level data"
    },
    "a11y": {
      "rung": "{{name}}. {{state}}",
      "rungWithXp": "{{name}}, {{xp}}. {{state}}"
    }
  },
  "personalRecordsInfo": {
    "title": "What are Personal Records?",
    "intro": "These are the four measures of your progress in Agapella.",
    "close": "Close",
    "scrimA11y": "Close the Personal Records explainer",
    "banner": {
      "title": "Your path — at your own pace",
      "subtitle": "Every step matters"
    },
    "closing": "You are on your path, and every step matters.",
    "xpUnit": "XP",
    "dayForms": {
      "one": "day",
      "few": "days",
      "many": "days"
    },
    "records": {
      "streak": {
        "title": "Longest streak",
        "description": "The longest run of consecutive days with a completed practice."
      },
      "practices": {
        "title": "Completed practices",
        "description": "The total number of practices you have completed."
      },
      "lives": {
        "title": "Live sessions attended",
        "description": "The total number of Live sessions you have joined."
      },
      "xp": {
        "title": "Total XP",
        "description": "Your current amount of Soul Light (XP)."
      }
    },
    "a11y": {
      "row": "{{title}}: {{value}}. {{description}}",
      "unavailable": "value unavailable"
    }
  },
  "milestonesInfo": {
    "title": "What are the Path Milestones?",
    "intro": "Path Milestones are the meaningful points of your Flame of Love. Keep your daily practice streak going to pass them one after another.",
    "close": "Close",
    "scrimA11y": "Close the Path Milestones explainer",
    "listTitle": "Path Milestones",
    "note": "Every milestone you reach opens the achievement of the same name. The badge joins your collection.",
    "days_one": "{{count}} day in a row",
    "days_other": "{{count}} days in a row",
    "summary": {
      "currentStreak": "Current streak",
      "nextMilestone": "Next milestone",
      "progress_one": "{{current}} of {{count}} day",
      "progress_other": "{{current}} of {{count}} days",
      "remaining_one": "{{count}} day to go",
      "remaining_other": "{{count}} days to go",
      "allDone": "Every milestone passed",
      "allDoneDescription": "You have passed every milestone of the Flame of Love. Keep the streak — it stays with you.",
      "unknownStreak": "The streak has not loaded yet"
    },
    "status": {
      "earned": "Earned",
      "inProgress": "In progress",
      "future": "Upcoming"
    },
    "state": {
      "errorTitle": "Could not load the Path Milestones",
      "errorMessage": "Please try again.",
      "retry": "Try again",
      "retryA11y": "Reload the Path Milestones",
      "stale": "Showing the last saved data",
      "loadingA11y": "Loading the Path Milestones"
    },
    "a11y": {
      "row": "{{name}}, {{days}}. {{status}}",
      "rowInProgress": "{{name}}, {{days}}. {{status}}, {{progress}}, {{remaining}}",
      "progressBar": "Progress towards the next milestone"
    }
  }
}
